import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  const { search } = useLocation(); // Get the search string from the URL
  return Object.fromEntries(new URLSearchParams(search)); // Convert search params to an object
};

export default useQueryParams;
